<template>
	<section>
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" :model="filters">
				<el-form-item>
					<el-input v-model="filters.name" placeholder="用户名" clearable></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" v-on:click="getFilterList">查询</el-button>
				</el-form-item>
				<el-form-item>
					<el-button type="default" @click="confirmUpdate=true">重置</el-button>
				</el-form-item>
        <el-form-item>
          <el-button type="primary" v-on:click="batchUpdateUserInfo">更新用户信息</el-button>
        </el-form-item>
			</el-form>
		</el-col>
		<!--列表 @selection-change="handleSelectionChange"-->
		<el-table :data="tableData" highlight-current-row v-loading="listLoading" style="width: 100%;">
			<!-- <el-table-column type="selection" width="45"></el-table-column> -->
			<el-table-column prop="id" label="ID" width="80">
			</el-table-column>
			<el-table-column prop="avatar" label="头像" width="100">
				<template slot-scope="image">
                    <img class="avatar" :src="image.row.avatar?image.row.avatar:require('../../assets/avatar.png')"  min-width="70" height="70" />
                 </template>
			</el-table-column>
			<el-table-column prop="nickName" label="登录名" width="200">
			</el-table-column>
			<el-table-column label="剩余金额" >
				<template slot-scope="scope">
					<el-button type="text"  @click="handleDetails(scope.$index, scope.row)">{{scope.row.remainder}}</el-button>
				</template>
			</el-table-column>
			<el-table-column label="作品数" >
				<template slot-scope="scope">
					<el-button type="text"  @click="handleWorks(scope.$index, scope.row)">{{scope.row.workNum}}</el-button>
				</template>
			</el-table-column>
			<el-table-column label="领取卡券数" >
				<template slot-scope="scope">
					<el-button type="text" @click="handleCoupon(scope.$index, scope.row)">{{scope.row.couponNum}}</el-button>
				</template>
			</el-table-column>
			<el-table-column label="操作" width="120" class="button-bar" fixed='right'>
				<template slot-scope="scope">
					<el-button type="text"  size="small" @click="handleCharge(scope.$index, scope.row)">充值</el-button>
				</template>
			</el-table-column>
		</el-table>
		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<el-pagination  background layout="total,prev, pager, next, jumper, sizes" @current-change="handleCurrentChange"
				@size-change="handleSizeChange" :page-sizes="[10, 20, 50, 100]" :current-page.sync="currentPage"
				:page-size="pageSize" :total="totalNumber" style="float:left;">
			</el-pagination>
		</el-col>
		<el-dialog title="充值" :visible.sync="chargeFormVisible" :close-on-click-modal="false">
			<el-form :model="chargeForm" label-width="80px" :rules="addFormRules" ref="chargeform">
				<el-form-item label="金额">
					<el-input placeholder="请输入金额" v-model="chargeForm.money" clearable>
					</el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="chargeFormVisible = false">取消</el-button>
				<el-button type="primary" @click.native="chargeSubmit" :loading="chargeLoading">确定</el-button>
			</div>
		</el-dialog>
	</section>
</template>

<script>
	import util from '../../common/js/util'
	//import NProgress from 'nprogress'
	import { getUserListPage, removeUser, batchRemoveUser, editUser, addUser } from '../../api/api';

	export default {
		data() {
			return {
				loadingPass: false,
				loadingUnpass: false,
				checkVisible: false,
				currentId: null,
				chargeFormVisible: false,
				selcetedCheckState: null,
				selectedShelvesState: null,
				multipleSelection: [],
				totalNumber: null,
				tableData: null,
				pageSize: 10,
				currentPage: 1,
				shelvesState: [{ label: '付费', value: 'ON_SHELVES' }, { label: '普通', value: 'OFF_SHELVES' },],
				checkState: [{ label: '审核中', value: 'WAITING' }, { label: '审核通过', value: 'PASSED' }, { label: '不通过', value: 'REJECTED' }],
				filters: {
					name: ''
				},
				users: [],
				total: 0,
				page: 1,
				listLoading: false,
				sels: [],//列表选中列

				editFormVisible: false,//编辑界面是否显示
				editLoading: false,
				editFormRules: {
					name: [
						{ required: true, message: '请输入姓名', trigger: 'blur' }
					]
				},
				//编辑界面数据
				editForm: {
					id: 0,
					name: '',
					sex: -1,
					age: 0,
					birth: '',
					addr: ''
				},

				addFormVisible: false,//新增界面是否显示
				addLoading: false,
				addFormRules: {
					name: [
						{ required: true, message: '请输入金额', trigger: 'blur' }
					]
				},
				//新增界面数据
				addForm: {
					name: '',
					sex: -1,
					age: 0,
					birth: '',
					addr: ''
				},
				chargeLoading: false,
				chargeForm: {
					money: 0,
				},
				confirmUpdate: false

			}
		},
		methods: {
			async setCheckState(index) {
				let state = 'WAITING'
				if (index == 0) {
					this.loadingUnpass = true;
					state = 'REJECTED'
				} else {
					this.loadingPass = true;
					state = 'PASSED'
				}
				try {
					let result = await this.$http.post(this,`/project/${this.currentId}/audit/${state}`);
					if (index == 0) {
						this.loadingUnpass = false;
					} else {
						this.loadingPass = false;
					}
					if (result && result.code == 200) {
						this.$message({
							message: '完成',
							type: 'success'
						});
						this.getList(this.currentPage - 1);
					}
				} catch (e) {
					this.loadingPass = false;
					this.loadingUnpass = false;
				}
				this.checkVisible = false;
			},
			handleSelectionChange(val) {
				console.log('checkb0x-', val)
				this.multipleSelection = val;
			},
			formatDatas(item) {
				return {
					id: item.id,
					avatar: item.avatar||'',
					remainder: item.wallet||item.remainder||0,
					nickName: item.nickName||item.username||item.nickname,
					share: item.share||'',
					workNum: item.workNum,
					couponNum: item.couponNum
				}
			},
			handleCurrentChange(val) {
				this.currentPage = val;
				this.getList(this.currentPage);
			},
			getFilterList() {
				this.currentPage = 1;
				this.getList(this.currentPage);
			},
			handleSizeChange(val) {
				this.pageSize = val;
				this.currentPage = 1;
				this.getList(this.currentPage);
			},
			async getList(index) {
				let condition = {}
				if(this.filters.name) {
					condition.nickname = this.filters.name;
				}
				condition.currentPage = index;
				condition.pageSize = this.pageSize
				try{
					this.listLoading = true;
					let result = await this.$http.post(this,'/user/getAllUserList', {},condition);
					if (result && result.code == 200) {
						this.tableData = result.data.rows.map((item) => { return this.formatDatas(item)});
						this.totalNumber = result.data.total;
						this.listLoading = false;
					}
				} catch(e){
					this.listLoading = false;
				}

			},
			formatShelveState(row, column) {
				let temp = this.shelvesState.filter((item) => {
					return item.value == row.shelvesState;
				})
				return temp[0].label;
			},
			formatCheckState(row, column) {
				let temp = this.checkState.filter((item) => {
					return item.value == row.auditState;
				})
				return temp[0].label;
			},
			formateDate(row, column) {
				if (!row.endTime) {
					return '';
				}
				return new Date(row.endTime).format("yyyy/MM/dd hh:mm");
			},
			handleCharge: function (index, row) {
				this.currentId = row.id;
				this.chargeFormVisible = true;
			},
			handleWorks(index, row)  {
				this.$router.push({ path: '/consumerUser/works', query: { userid: row.id,userName: row.nickName,totalWorks:row.workNum } });
			},
			handleDetails(index,row){
				this.$router.push({ path: '/consumerUser/details', query: { userId: row.id,userName: row.nickName } });
			},
			handleCoupon(index,row){
				this.$router.push({ path: '/consumerUser/coupon', query: { userId: row.id,userName: row.nickName,couponNum:row.couponNum } });
			},
			handleCheck: function (index, row) {
				this.checkVisible = true;
				this.currentId = row.id;
			},
			//显示新增界面
			handleAdd: function () {
				this.$router.push('/table/table1')
				this.addFormVisible = true;
				this.addForm = {
					name: '',
					sex: -1,
					age: 0,
					birth: '',
					addr: ''
				};
			},
			//编辑
			editSubmit: function () {
				this.$refs.editForm.validate((valid) => {
					if (valid) {
						this.$confirm('确认提交吗？', '提示', {}).then(() => {
							this.editLoading = true;
							//NProgress.start();
							let para = Object.assign({}, this.editForm);
							para.birth = (!para.birth || para.birth == '') ? '' : util.formatDate.format(new Date(para.birth), 'yyyy-MM-dd');
							editUser(para).then((res) => {
								this.editLoading = false;
								//NProgress.done();
								this.$message({
									message: '提交成功',
									type: 'success'
								});
								this.$refs['editForm'].resetFields();
								this.editFormVisible = false;
								//	this.getUsers();
							});
						});
					}
				});
			},
			chargeSubmit() {
				this.$refs.chargeform.validate(async (valid) => {
					if (valid) {
						this.chargeLoading = true;
						let para = {
							amount: this.chargeForm.money,
						}
						try{
							let result = await this.$http.post(this,`/user/${this.currentId}/recharge`, para);
							this.chargeLoading = false;
							if (result.code == 200) {

								this.$message({
									message: '充值成功',
									type: 'success'
								});
								this.chargeForm.money = 0;
								this.chargeFormVisible = false;
								this.getList(this.currentPage - 1);
							} else {
								this.$message({
									message: '充值失败',
									type: 'fail'
								});
							}
						} catch (e) {
							this.chargeLoading = false;
							this.$message({
									message: '充值失败',
									type: 'fail'
								});
						}

					}
				});
			},
			//新增
			addSubmit: function () {
				this.$refs.addForm.validate((valid) => {
					if (valid) {
						this.$confirm('确认提交吗？', '提示', {}).then(() => {
							this.addLoading = true;
							//NProgress.start();
							let para = Object.assign({}, this.addForm);
							para.birth = (!para.birth || para.birth == '') ? '' : util.formatDate.format(new Date(para.birth), 'yyyy-MM-dd');
							addUser(para).then((res) => {
								this.addLoading = false;
								//NProgress.done();
								this.$message({
									message: '提交成功',
									type: 'success'
								});
								this.$refs['addForm'].resetFields();
								this.addFormVisible = false;
								//this.getUsers();
							});
						});
					}
				});
			},
			selsChange: function (sels) {
				this.sels = sels;
			},
			//批量删除
			batchRemove: function () {
				var ids = this.sels.map(item => item.id).toString();
				this.$confirm('确认删除选中记录吗？', '提示', {
					type: 'warning'
				}).then(() => {
					this.listLoading = true;
					//NProgress.start();
					let para = { ids: ids };
					batchRemoveUser(para).then((res) => {
						this.listLoading = false;
						//NProgress.done();
						this.$message({
							message: '删除成功',
							type: 'success'
						});
						//this.getUsers();
					});
				}).catch(() => {

				});
			},
			batchUpdateUserInfo(){
				this.$http.post(this,'/user/batchUpdateUserInfo')
				this.$message({
					message: '后台数据正在更新，请过段时间查看！',
					type: "warning"
				})
				this.confirmUpdate = false
			}
		},
		mounted() {
			this.getList(0);
		}
	}

</script>

<style scoped>
	.el-button+.el-button {
		margin-left: 4px;
	}

	.el-button--small,
	.el-button--small.is-round {
		padding: 8px 10px;
	}

	.el-button--text {
		padding-left: 0;
		padding-right: 0;
	}
	.avatar {
		width: 40px;
		height: 40px;
		border-radius: 20px;
	}

	.comf-btn {
		display: flex;
		justify-content: flex-end;
	}
</style>
